module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg ger 7-43c28b66484b1c53c414f634531695b2.jpg";